import PropTypes from 'prop-types';
import { PureComponent, cloneElement } from 'react';
import { noop } from 'lodash';
/* eslint-disable */
class TouchEvents extends PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
    onTap: PropTypes.func
  };
  static defaultProps = {
    onTap: noop
  };
  onTouchStart = e => {
    const {
      onTouchStart
    } = this.props.children.props;
    this.touchStarted = true;
    this.applyHandler(onTouchStart, e);
  };
  onTouchMove = e => {
    const {
      onTouchMove
    } = this.props.children.props;
    this.applyHandler(onTouchMove, e);
    this.touchMoved = true;
  };
  onTouchEnd = e => {
    const {
      onTouchEnd,
      onTap
    } = this.props.children.props;
    this.applyHandler(onTouchEnd, e);
    if (this.touchStarted && !this.touchMoved) {
      this.applyHandler(onTap, e);
    }
    this.touchStarted = this.touchMoved = false;
  };
  onTouchCancel = () => this.touchStarted = this.touchMoved = false;
  touchStarted = false;
  touchMoved = false;
  applyHandler(onHandle, e) {
    (onHandle || noop)(e);
  }
  render() {
    return /*#__PURE__*/cloneElement(this.props.children, {
      onTouchStart: this.onTouchStart,
      onTouchMove: this.onTouchMove,
      onTouchEnd: this.onTouchEnd,
      onTouchCancel: this.onTouchCancel
    });
  }
}
/* eslint-enable */
export default TouchEvents;